import { useState, useCallback } from "react";
import { getAuditLogs } from "services/auditLogService";
// import { getAuditLogs } from "../../services/auditLogService";

const useAuditLogs = () => {
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [infoPagination, setInfoPagination] = useState<any>({});
  const [error, setError] = useState<any>(null);

  const fetchAuditLogs = useCallback(async (filters: any = {}) => {
    try {
      setLoading(true);
      const res = await getAuditLogs(filters);
      setLogs(res.data.items);
      setInfoPagination(res.data.meta);
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const mapEntityToKey = (value: string) => {
    switch (value) {
      case "Student":
        return "student";
      case "Teacher":
        return "teacher";
      case "Guardian":
        return "guardian";
      case "Class":
        return "class";
      case "Absence":
        return "absence";
      case "ExamSession":
        return "exam_sessions";
      case "Planning":
        return "planning";
      case "Supplier":
        return "supplier";
      case "ExpenseCategory":
        return "expense_category";
      case "Expense":
        return "expenses";
      case "FeeType":
        return "fee_type";
      case "Fee":
        return "fee";
      case "PaymentFee":
        return "payment_fee";
      case "User":
        return "user";
      case "FeePayment":
        return "fee_payment";
      case "Instance":
        return "instance_settings";
      case "StudentImport":
        return "import_button_open";
      case "UserManagement":
        return "user_management";
      case "Leave":
        return "leave.title";
      case "staff":
        return "staff.title";
      case "StudentExit":
        return "studentExit.title";
      case "AuthorizedPickUpPerson":
        return "authorizedPickUpPerson.title";
      case "CashBox":
        return "cashbox.title";
      case "CashTransaction":
        return "cashboxTransactions.title";
      default:
        return value?.toLowerCase(); // fallback
    }
  };

  return {
    logs,
    loading,
    error,
    infoPagination,
    fetchAuditLogs,
    mapEntityToKey,
  };
};

export default useAuditLogs;
